<script lang="ts">
import { initStore } from '@/stores/store-manager';
import type { PropType } from 'vue';
import { defineComponent, toRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { ContentEntityDto } from '@/api/dto/content.dto';
import { CategoryConnectRecEntityDto } from '@/api/dto/category.dto';
import MainContentsItem from '@/components/layout/MainContentsItem.vue';
import ListItemSkeleton from '@/components/layout/contents/ListItemSkeleton.vue';

export default defineComponent({
	name: 'MainContentsList',
	props: {
		isLoaded: {
			type: Boolean,
			required: true,
			default: false,
		},
		isVertical: {
			type: Boolean,
			default: false,
		},
		data: {
			type: Array as PropType<Array<CategoryConnectRecEntityDto | ContentEntityDto>>,
			required: true,
		},
		getContentsList: {
			type: Function as PropType<() => void>,
			required: false,
			default: () => ({}),
		},
	},
	components: {
		ListItemSkeleton,
		MainContentsItem,
	},

	setup(props) {
		const { t } = useI18n({ useScope: 'global' });
		const storeManager = initStore();
		const computedLoaded = toRef(props, 'isLoaded');
		const computedData = toRef(props, 'data');

		return {
			t,
			storeManager,
			computedLoaded,
			computedData,
		};
	},
});
</script>

<template>
	<template v-if="computedLoaded">
		<template v-if="computedData.length > 0">
			<div class="apoc-list-wrapper main-list">
				<main-contents-item
					v-for="item in computedData"
					:data="item"
					:key="item.contentIdx"
					:callbacks="{ getList: getContentsList }"
					:is-vertical="isVertical"
					class="list-item" />
			</div>
		</template>
		<template v-else>
			<div class="list-empty">
				<span>{{ t('common.empty') }}</span>
			</div>
		</template>
	</template>
	<template v-else>
		<div class="apoc-list-wrapper fake-apoc-list-wrapper main-list" style="overflow: hidden">
			<div class="flicking-camera">
				<list-item-skeleton v-for="(item, index) in 12" :key="`${index}_${item}`" class="list-item" />
			</div>
		</div>
	</template>
	<slot />
</template>

<style scoped></style>
